class PageAide {
  private container: HTMLElement | null;

  constructor() {
    this.container = document.querySelector('.page-aide-aides');
    this._initSelects();
  }

  private _initSelects() {
    const selectElement = this.container?.querySelector<HTMLSelectElement>('.page-aide-aides__filters.mobile select');

    if (!selectElement) return;

    selectElement.addEventListener('change', () => {
      const selectedOption = selectElement.options[selectElement.selectedIndex];
      const targetUrl = selectedOption.dataset.target;

      if (targetUrl) {
        window.location.href = targetUrl;
      }
    });
  }
}

export const pageAide = new PageAide();
